import React from "react"
import PropTypes from "prop-types"

import { RedocStandalone } from 'redoc';

const Redoc = (props) => {
  return (
    <RedocStandalone specUrl={props.openapiDoc}/>
  )
}

Redoc.propTypes = {
  openapiDoc: PropTypes.string
};

export default Redoc
